"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventType = void 0;
var EventType;
(function (EventType) {
    EventType["NOTIFICATION_MANAGER_QUEUE_READY_EVENT"] = "NOTIFICATION_MANAGER_QUEUE_READY_EVENT";
})(EventType = exports.EventType || (exports.EventType = {}));
